import { useEffect, useRef, useState } from "react";

/**
 * Pega briefly clears validatemessage between re-renders; debounce clearing
 * so error styling does not flicker off during a triggerFieldChange cycle.
 * Matches the debounce used in Text.tsx.
 */
export function useStableValidateMessage(message?: string): string | undefined {
  const [stableMessage, setStableMessage] = useState(message);
  const clearErrorTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (message) {
      clearTimeout(clearErrorTimeoutRef.current);
      setStableMessage(message);
    } else {
      clearErrorTimeoutRef.current = setTimeout(
        () => setStableMessage(undefined),
        100,
      );
    }

    return () => clearTimeout(clearErrorTimeoutRef.current);
  }, [message]);

  return stableMessage;
}
